import { render, staticRenderFns } from "./areaStatus.vue?vue&type=template&id=6b1060c8&scoped=true&"
import script from "./areaStatus.vue?vue&type=script&lang=js&"
export * from "./areaStatus.vue?vue&type=script&lang=js&"
import style0 from "./areaStatus.vue?vue&type=style&index=0&id=6b1060c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1060c8",
  null
  
)

export default component.exports